import { FormattedMessage } from 'react-intl';
import StepItem from '../stepItem/StepItem';
import { Modal } from '@iwoca/orion';
import messages from './MajorShareholderCheckAction.messages';
import { useState } from 'react';
import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import MSHPeople from './mshModal/MSHPeople';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';

const MajorShareholderCheckAction = ({
    status
}: {
    status: TFundingRequirementsSteps['0']['status'];
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <StepItem
                title={<FormattedMessage {...messages.title} />}
                caption={<FormattedMessage {...messages.caption} />}
                action={
                    <FundingStepActionButton
                        actionMessage={
                            <FormattedMessage {...messages.action} />
                        }
                        pendingMessage={
                            <FormattedMessage {...messages.pending} />
                        }
                        status={status}
                        handleFundingStepAction={() => setIsModalOpen(true)}
                    />
                }
            />
            <Modal isOpen={isModalOpen} onClose={handleModalClose} closeIcon>
                <MSHPeople onClose={handleModalClose} />
            </Modal>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default MajorShareholderCheckAction;
